import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";

export class ApplyForOdCoDto {
    applyOdCoId: number;
    employeeId: number;
    employeeCode: string;
    type: any;
    fromDate: any;
    toDate: any;
    noOfDays: number;
    leaveReason: string;
    isActive: boolean;
    updatedAt: Date | any;
    updatedUser: string;
    rejectionReason: string;
    createdAt: Date | any;
    createdUser: string;
    versionFlag: number;
    status?: LeaveApprovalStatusEnum;
    employeeName?: string;
  

    constructor(
        applyOdCoId: number,
        employeeId: number,
        employeeCode: string,
        type: any,
        fromDate: Date,
        toDate: Date,
        noOfDays: number,
        leaveReason: string,
        isActive: boolean,
        updatedAt: Date | any,
        updatedUser: string,
        rejectionReason: string,
        createdAt: Date | any,
        createdUser: string,
        versionFlag: number,
        status?: LeaveApprovalStatusEnum,
        employeeName?: string

    ) {
        this.applyOdCoId = applyOdCoId;
        this.employeeId = employeeId;
        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.type = type;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.noOfDays = noOfDays;
        this.leaveReason = leaveReason;
        this.isActive = isActive;
        this.updatedAt = updatedAt;
        this.rejectionReason = rejectionReason;
        this.updatedUser = updatedUser;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.versionFlag = versionFlag;
        this.status = status;
        this.employeeName = employeeName;

    }
}

export class ApplyForOdCoModelDtoReq {
    data:ApplyForOdCoDto[]
    user:string
constructor(
    data:ApplyForOdCoDto[],
    user:string
){
this.data = data
this.user = user
}}

